import { Route } from 'vue-router';

export const ReferralRoute: Record<string, Partial<Route>> = {
  VAULT_SELF_REFERRAL: {
    path: 'vault-self-referral',
    name: 'vault-self-referral'
  },
  SETTLEMENT_SELF_REFERRAL: {
    path: 'settlement-self-referral',
    name: 'settlement-referral-self-referral'
  }
};
